import type { FacilityStatus } from '@/types';
import styles from './StatusTag.module.css';

interface Props {
  status: FacilityStatus | 'activa' | 'pendiente' | 'sin-datos';
  children?: React.ReactNode;
}

export function StatusTag({ status, children }: Props) {
  const cls =
    status === 'activa'
      ? styles.activa
      : status === 'sin-datos'
        ? styles.sinDatos
        : styles.pendiente;
  const label =
    children ||
    (status === 'activa' ? 'Activa' : status === 'sin-datos' ? 'Sin datos' : 'Por configurar');
  return <span className={`${styles.tag} ${cls}`}>{label}</span>;
}
